












import { ObjectFactory } from '@/config/objectFactory';
import { Component , Vue } from 'vue-property-decorator';
@Component({})
export default class LeftNavigationBar extends Vue {
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private showPayoutsTab = true;

    private async mounted() {
        if (this.sessionInfo.scopes.includes('interpreter') && this.$store.state.isChildInterpreter) {
            this.showPayoutsTab = false;
        }
    }
}
